import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'LMD - Le Vrai Journal du Digital';
const SITE_TAGLINE = 'Le digital, expliqué autrement.';
const SITE_ORIGIN = 'https://lmd.lemeilleurdu.digital';
const DEFAULT_OG = 'https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=1400&q=80';

const buildUrl = (path = '/') => {
  return new URL(path, SITE_ORIGIN).toString();
};

const normalizeImageUrl = (value) => {
  const image = String(value || '').trim();
  if (!image) return DEFAULT_OG;
  if (/^https?:\/\//i.test(image)) return image;
  return new URL(image, SITE_ORIGIN).toString();
};

const Seo = ({ title, description, path = '/', image = DEFAULT_OG, type = 'website', robots = 'index,follow' }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const metaDescription = description || SITE_TAGLINE;
  const canonical = buildUrl(path);
  const metaImage = normalizeImageUrl(image);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={metaImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default Seo;
